import styled from '@emotion/styled'

import {
  FloorPlanColorScheme,
  getFloorPlanCanvasMarkerColors,
  getFloorPlanVisualColors,
} from '../utils/floorPlanVisuals'

type DarkContainerProps = {
  $colorScheme: FloorPlanColorScheme
}

export const getDarkContainerStyles = (colorScheme: FloorPlanColorScheme) => {
  const canvasMarkerColors = getFloorPlanCanvasMarkerColors()
  const themedColors = getFloorPlanVisualColors(colorScheme)

  return `
      .checkpointToolTipText,
      .checkpointToolTipL,
      .checkpointToolTipR {
        fill: ${themedColors.checkpointTooltipText};
        font-size: 18px;
        font-weight: 700;
      }

      .checkpointToolTipBox,
      .checkpointCircleToolTipL,
      .checkpointCircleToolTipR {
        fill: ${themedColors.checkpointTooltipBackground};
      }

      .connections-group.editOn,
      .alarm-group.editOn,
      .door-group.editOn,
      .camera-group.editOn {
        cursor: grab;
      }

      .cameraCircle {
        fill: ${canvasMarkerColors.markerBackground};
        stroke: none;
      }

      .deviceMarkerRing {
        fill: none;
        stroke: ${canvasMarkerColors.markerRing};
        stroke-width: 2px;
        shape-rendering: geometricPrecision;
      }

      .cameraView {
        fill: ${canvasMarkerColors.coneFill};
        fill-opacity: 0.1;
        stroke: none;
      }

      .cameraControl.isFovFocused .cameraView,
      .cameraControl.isFovHovered .cameraView {
        fill: ${canvasMarkerColors.coneFillFocused};
        fill-opacity: 0.2;
        stroke: ${canvasMarkerColors.coneEdge};
        stroke-width: 1px;
      }

      .dragged .cameraCircle {
        filter: drop-shadow(0 0 8px ${themedColors.editFrame});
      }

      .invalidPosition .cameraCircle {
        filter: drop-shadow(0 0 8px ${themedColors.deleteZoneActive});
      }

      .isHighlighted {
        filter: drop-shadow(0 0 8px ${canvasMarkerColors.coneEdge});
      }

      .floorDeviceHandle {
        fill: ${canvasMarkerColors.markerGlyph};
        stroke: ${canvasMarkerColors.markerRing};
        stroke-width: 1.5px;
      }

      .removeIconSvg,
      .editIconSvg,
      .checkpointMarker {
        cursor: pointer;
      }
    `
}

export const DarkContainer = styled.div<DarkContainerProps>`
  height: 100%;

  ${({ $colorScheme }) => getDarkContainerStyles($colorScheme)}

  svg {
    overflow: visible;
  }
`
